import React, {Component} from 'react';
import Button from 'material-ui/Button';
import List, {ListItem, ListItemText} from 'material-ui/List';
import axios from 'axios';
import Paper from 'material-ui/Paper';
import TextField from 'material-ui/TextField';
import Snackbar from 'material-ui/Snackbar';
import './SpotifySearch.css';
import firebase from 'firebase';

class SpotifySearch extends Component {
  constructor(props) {
    super(props);
    let spotifyToken = sessionStorage.getItem("spotifyToken");
    let feesieId = sessionStorage.getItem("feesieId");

    this.state = {
      feesieId: feesieId,
      searchQuery: "",
      searchItems: [],
      spotifyToken: spotifyToken,
      songSnackBar: false,
      lastestSongAddedKey: ""
    };

    this.searchSpotify = this.searchSpotify.bind(this);
    this.hideSearch = this.hideSearch.bind(this);
    this.addSpotifyItemToQueue = this.addSpotifyItemToQueue.bind(this);
    this.hideAddSongSnackbar = this.hideAddSongSnackbar.bind(this);
    this.updateLastestSongAddedKey = this.updateLastestSongAddedKey.bind(this);
  }

  hideSearch() {
    this.setState({searchShown: false});
  }

  hideAddSongSnackbar() {
    this.setState({songSnackBar: false})
  }


  searchSpotify(evt) {
    let _this = this;
    let searchQuery = evt.target.value;
    if (searchQuery === '') {
      _this.setState({searchItems: []});
    }
    this.setState({searchQuery: searchQuery});
    axios.get('https://api.spotify.com/v1/search', {
      params: {
        q: searchQuery,
        type: "track"
      },
      headers: {
        'Authorization': "Bearer " + this.state.spotifyToken
      }

    }).then(function(response) {
      console.log(response.data.tracks.items);
      _this.setState({searchItems: response.data.tracks.items});
    }).catch(function(error) {
      console.log(error);
    });
  }

  updateLastestSongAddedKey(newPostKey){
    console.log(newPostKey);
    this.setState({lastestSongAddedKey: newPostKey});
  }

  addItemToFirebasePlaylist(type = "track", searchItem) {
    let _this = this;
    if (type = "track") {
      let feesieId = this.state.feesieId;
      let updates = {};
      let newPostKey = firebase.database().ref('/feesies/' + feesieId).child('feesie_songs').push().key;
      let postData = {
        s_id: searchItem.id,
        name: searchItem.name,
        key: newPostKey,
        artistName: searchItem.artists[0].name,
        albumArtUrl: searchItem.album.images[2].url,
        votes: 0
      };
      updates['/feesies/' + feesieId + '/feesie_songs/' + newPostKey] = postData;
      firebase.database().ref().update(updates);
      _this.updateLastestSongAddedKey(newPostKey);
      _this.hideSearch();
    }
  }

  addSpotifyItemToQueue = param => e => {
    this.addItemToFirebasePlaylist("track", param);
    this.setState({songSnackBar: true})
  };

  undoLatestSongAddition() {
    let lastestSongAddedKey = this.state.updateLastestSongAddedKey;
    let feesieId = this.state.feesieId;
    firebase.database().ref('/feesies/' + feesieId).child('feesie_songs').child(lastestSongAddedKey).remove();
  }

  render() {
    return <div className="main-content">
      <Paper className="spotify-search-bar" elevation={4}>
        <TextField className="spotify-search-bar-input" onChange={this.searchSpotify} id="search" value={this.state.searchQuery} placeholder="Zoeken" type="search" margin="normal"/>
      </Paper>
      <div className="search-items-list">
        <List className="song-list">
          {
            this.state.searchItems.map(searchItem => {
              return <ListItem onClick={this.addSpotifyItemToQueue(searchItem)} button={true}>
                <img src={searchItem.album.images[2].url}></img>
                <ListItemText primary={searchItem.name} secondary={searchItem.artists[0].name}/>
              </ListItem>
            })
          }
        </List>
      </div>
      <Snackbar
         anchorOrigin={{
           vertical: 'bottom',
           horizontal: 'left',
         }}
         open={this.state.songSnackBar}
         autoHideDuration={300}
         SnackbarContentProps={{
           'aria-describedby': 'message-id',
         }}
         message={<span id="message-id">Song added to Feesie</span>}
         action={[
           <Button key="undo" color="orange" size="small" onClick={this.undoLatestSongAddition}>
             UNDO
           </Button>
         ]}
       />
    </div>
  }
}
export default SpotifySearch;



// WEBPACK FOOTER //
// ./src/SpotifySearch.js